<section class="container-transparent">
  <ng-content></ng-content>
</section>
